/* shah */
import React from 'react'

const ReadingModeIcon = () => {
    return (
        <svg id="SmallBoxSVG-readingMode" version="1.0" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            >
                <path d="M1970 4780 c-11 -11 -22 -30 -25 -42 -3 -13 -4 -200 -3 -417 l3 -395
80 -31 c44 -18 104 -44 134 -57 l55 -25 110 53 c398 191 804 227 1261 113 79
-20 95 -28 154 -79 36 -32 117 -109 179 -172 l112 -115 0 -1114 c0 -962 -2
-1117 -15 -1135 -12 -18 -162 -58 -905 -244 l-891 -223 -132 32 c-73 17 -135
31 -139 31 -5 0 -8 -128 -8 -285 0 -299 4 -333 45 -349 22 -8 2508 -8 2530 0
47 18 45 -85 45 2234 0 2319 2 2216 -45 2234 -9 3 -142 6 -294 6 l-278 0 -6
-82 c-12 -147 -83 -242 -200 -268 -75 -16 -919 -13 -984 3 -113 30 -177 120
-189 265 l-7 82 -283 0 c-269 0 -285 -1 -304 -20z m444 -71 c37 -29 37 -89 0
-118 -23 -18 -41 -21 -138 -21 -99 0 -115 2 -134 20 -28 27 -37 62 -21 92 23
42 39 47 155 48 98 0 115 -3 138 -21z"/>
                <path d="M2730 4731 c0 -54 4 -74 21 -95 l20 -26 479 0 479 0 20 26 c17 21 21
41 21 95 l0 69 -520 0 -520 0 0 -69z"/>
                <path d="M2973 3879 c-176 -14 -397 -73 -590 -158 l-88 -38 -3 -212 c-1 -116
1 -211 6 -211 4 0 46 16 92 36 377 159 790 194 1163 99 l27 -7 -2 202 -3 203
-62 23 c-141 53 -357 78 -540 63z"/>
                <path d="M1160 3854 c-71 -9 -206 -35 -257 -50 l-53 -15 0 -200 c0 -186 1
-200 18 -195 43 14 278 46 377 52 245 14 567 -49 821 -161 31 -14 58 -25 60
-25 3 0 3 95 2 212 l-3 211 -66 27 c-120 50 -251 90 -373 116 -98 21 -156 26
-306 29 -102 2 -201 1 -220 -1z"/>
                <path d="M618 3613 l-58 -59 0 -967 c0 -532 4 -967 8 -967 4 0 31 24 60 53
l52 53 -2 972 -3 973 -57 -58z"/>
                <path d="M3740 2702 l0 -968 58 -57 c32 -31 61 -57 65 -57 4 0 7 436 7 968 l0
968 -58 57 c-32 31 -61 57 -65 57 -4 0 -7 -436 -7 -968z"/>
                <path d="M1050 3270 c-58 -10 -125 -25 -150 -33 l-45 -13 -3 -203 -2 -204 32
7 c277 58 531 60 793 6 115 -24 270 -70 364 -109 41 -17 78 -31 82 -31 5 0 9
89 9 199 l0 198 -72 33 c-105 47 -317 116 -433 140 -148 32 -432 37 -575 10z"/>
                <path d="M2869 3275 c-161 -26 -316 -72 -484 -145 l-95 -42 0 -204 c0 -112 1
-204 3 -204 1 0 39 15 83 34 121 51 285 102 414 128 101 20 143 23 340 23 194
-1 239 -4 327 -23 55 -12 106 -22 112 -22 8 0 11 59 9 202 l-3 203 -65 17
c-175 48 -452 62 -641 33z"/>
                <path d="M2835 2699 c-141 -24 -334 -86 -452 -143 l-93 -45 0 -201 c0 -110 4
-200 9 -200 4 0 39 14 77 31 364 166 752 207 1106 118 42 -10 81 -19 87 -19 8
0 11 64 11 204 l0 203 -75 22 c-183 55 -458 67 -670 30z"/>
                <path d="M1045 2689 c-27 -4 -82 -15 -122 -24 l-73 -16 0 -205 c0 -112 4 -204
8 -204 4 0 49 9 99 20 327 71 696 34 1049 -106 62 -24 115 -44 118 -44 4 0 5
91 4 203 l-3 202 -120 43 c-149 54 -347 106 -486 126 -114 17 -386 20 -474 5z"/>
                <path d="M1150 2133 c-53 -5 -189 -32 -247 -49 l-53 -15 0 -143 0 -143 123 -6
c232 -11 491 -70 727 -164 116 -46 308 -139 388 -188 l42 -26 0 268 0 269 -27
11 c-16 6 -73 30 -128 53 -256 107 -577 159 -825 133z"/>
                <path d="M2985 2129 c-195 -19 -452 -88 -628 -167 l-67 -31 0 -260 c0 -153 4
-261 9 -261 5 0 47 23 93 52 323 201 742 328 1078 328 l110 0 0 139 0 139 -77
21 c-154 40 -357 56 -518 40z"/>
                <path d="M3340 1623 c-302 -30 -633 -148 -967 -348 l-83 -49 0 -66 c0 -37 2
-69 5 -72 5 -5 1484 360 1495 369 2 2 -30 38 -72 80 -74 74 -79 77 -135 84
-59 7 -180 9 -243 2z"/>
                <path d="M710 1535 c-41 -41 -72 -76 -69 -78 2 -2 338 -87 747 -189 l742 -186
0 74 0 73 -73 45 c-316 197 -800 336 -1172 336 l-101 0 -74 -75z"/>
            </g>
        </svg>

    )
}

export default ReadingModeIcon